module.exports = __webpack_public_path__ + "static/task-manager-ade18f33aa26f4f2fda40386139f1ef2.gif";